import { IBusiness } from 'src/models';

// 카테고리리스트에서 drag한 카테고리 찾기
const findBusinessInTree = (businesses: IBusiness[], targetSid: number): IBusiness | undefined => {
  for (const business of businesses) {
    if (business.businessSid === targetSid) return business;
  }
  return undefined;
};

export default findBusinessInTree;
